export default {
  Views: {
    Details: {
      Components: {
        Main: {
          Components: {
            Overview: {
              "Author": "Author",
              "Created_at": "Created at",
              "Last_modified": "Last modified",
              "Updated_at": "Updated at"
            }
          },
          index: {
            "Active": "Active",
            "Inactive": "Inactive"
          }
        },
        Header: {
          "Entities": "Entities",
          "List": "List",
          "Active": "Active",
          "Edit": "Edit",
          "Entity": "Entity",
          "activate": "activate",
          "deactivate": "deactivate",
          "You_can_action_Entity_here": "You can {action} Entity here",
          "An_error_occurred_while_updating_Entity": "An error occurred while updating Entity"
        }
      },
      index: {}
    },
    List: {
      Components: {
        Header: {
          "Search": "Search ...",
          "Add_Entity": "Add Entity"
        }
      },
      index: {
        "Title": "Title",
        "Created_At": "Created At",
        "Updated_At": "Updated At",
        "Author": "Author",
        "Last_Modified": "Last Modified",
        "Active": "Active",
        "Open": "Open",
        "Edit": "Edit",
        "Generate": "Generate",
        "Delete": "Delete",
        "An_error_occurred_while_updating_Entity": "An error occurred while updating Entity",
        "Successfully_updated_Entity": "Successfully updated Entity",
        "Remove_Entity": "Remove Entity",
        "Youre_about_to_delete_Entity_title_Would_you_like_to_proceed_with_this_action": "You're about to delete Entity {title}. Would you like to proceed with this action?",
        "Cancel": "Cancel",
        "Entity_title_successfully_deleted": "Entity {title} successfully deleted"
      }
    }
  }
}
